export const config = {
    tabs: {
        types: {
            tabGroup: 'config',
            enabled: ({ datatype, treeNode })=>datatype == 10 || treeNode.nodeType == 'domain:byType',
            parts: [
                'TypesConfig'
            ],
            order: 50,
            acl: 'g:admin'
        },
        type: {
            tabGroup: 'config',
            enabled: ({ datatype, treeNode })=>[
                    0,
                    1,
                    2,
                    3
                ].includes(datatype) || treeNode.nodeType == 'domain:byType:type',
            parts: [
                'TypeConfig'
            ],
            order: 51,
            acl: 'g:admin'
        }
    }
};
